module.exports = __webpack_public_path__ + "img/Mix2WordIcon.6f67177e.png";